import styled from "styled-components";

export const Input = styled.input`
  &[type=text] {
    border: 1px solid ${props => props.theme.color.lightGray} !important;
  }

  &[type=checkbox] {
    margin-right: ${props => props.theme.spacer.m8};
  }

  &:hover {
    border: 1px solid ${props => props.theme.color.primary} !important;
  }
`;

export const InputLabel = styled.label`

`;